import { Routes } from '@angular/router';
import { InicioComponent } from './web/inicio/inicio.component';
// import { BookingWidgetComponent } from './components/karve/booking-widget/booking-widget.component';
// import { authGuard } from './auth.guard';
import { Error404Component } from './web/error404/error404.component';
// import { DevelopmentComponent } from './web/development/development.component';

export const routeStructure: { [key: string]: string[] } = {
  home: ['inicio', 'home'],
  // product: ['dive-insurance', 'seguro-buceo', 'seguro-buceo'],
  privacy: ['privacidad', 'privacy', 'privacy'],
  terms: ['terminos', 'terms', 'terms'],
  legal: ['aviso-legal', 'legal-warning', 'legal-warning'],
  accident: ['caso-accidente', 'accident-case', 'accident-case'],
  contact: ['contacto', 'contact', 'kontakt'],
  renovationDivingCenter: [
    'diving-center-renovation',
    'renovacion-centros-buceo',
  ],
  renovationProDiver: ['pro-diver-renovation', 'renovacion-buceo-profesional'],
  clientArea: ['client-area', 'area-cliente', 'areacliente'],
};

export const routes: Routes = [
  { path: '', component: InicioComponent, pathMatch: 'full' },
  ...routeStructure['home'].map(path => ({
    path,
    component: InicioComponent,
  })),
  {
    path: 'login',
    loadChildren: () => import('@ls-commons/login').then(r => r.loginRoutes),
    data: {
      title: $localize`:@@login.title:Iniciar Sesión`,
      loginGoogle: false,
      linkBack: '/login',
    },
  },
  {
    path: 'dashboard',
    // title: $localize`:@@title.dashboard:Panel`,
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(r => r.dashboardRoutes),
  },

  {
    path: 'redsys-notify/:status_code',
    // title: $localize`:@@title.dashboard:Panel`,
    loadComponent: () =>
      import('./web/redsys-notify/redsys-notify.component').then(
        r => r.RedsysNotifyComponent
      ),
  },

  // ...routeStructure['product'].map(path => ({
  //   path,
  //   loadChildren: () =>
  //     import('./web/dive-insurance/dive-insurance.routes').then(
  //       r => r.diveInsuranceRoutes
  //     ),
  // })),

  // ...routeStructure['clientArea'].map(path => ({
  //   path,
  //   loadComponent: () =>
  //     import('./web/client-area/client-area.component').then(
  //       r => r.ClientAreaComponent
  //     ),
  // })),

  // {
  //   path: 'scubamedic',
  //   loadComponent: () =>
  //     import('./web/scubamedic/scubamedic.component').then(
  //       r => r.ScubamedicComponent
  //     ),
  // },
  // {
  //   path: 'scubamedic/:center_id',
  //   loadComponent: () =>
  //     import('./web/scubamedic/scubamedic.component').then(
  //       r => r.ScubamedicComponent
  //     ),
  // },
  {
    path: 'scubamedic/:center_id/oferta/:offer_code',
    loadComponent: () =>
      import('./web/scubamedic/scubamedic.component').then(
        r => r.ScubamedicComponent
      ),
  },
  // {
  //   path: 'dive-pro',
  //   loadComponent: () =>
  //     import('./web/dive-pro/dive-pro.component').then(r => r.DiveProComponent),
  // },
  // {
  //   path: 'dive-pro/:country_code',
  //   loadComponent: () =>
  //     import('./web/dive-pro/dive-pro.component').then(r => r.DiveProComponent),
  // },
  {
    path: 'aceptacion-gestor',
    loadComponent: () =>
      import('./web/aceptacion-gestor/aceptacion-gestor.component').then(
        r => r.AceptacionGestorComponent
      ),
  },
  {
    path: 'reminder/custom-insurance-renovation/:action/:token',
    loadComponent: () =>
      import('./web/reminder-control/reminder-control.component').then(
        r => r.ReminderControlComponent
      ),
  },
  {
    path: 'reminder/seguro/:action/:token',
    loadComponent: () =>
      import('./web/reminder-control/reminder-control.component').then(
        r => r.ReminderControlComponent
      ),
  },
  ...routeStructure['legal'].map(path => ({
    path,
    loadComponent: () =>
      import('./web/aviso-legal/aviso-legal.component').then(
        r => r.AvisoLegalComponent
      ),
  })),

  // ...routeStructure['contact'].map(path => ({
  //   path,
  //   loadComponent: () =>
  //     import('./web/contacto/contacto.component').then(
  //       r => r.ContactoComponent
  //     ),
  // })),

  ...routeStructure['renovationDivingCenter'].map(path => ({
    path,
    loadComponent: () =>
      import(
        './web/renovation/renovation-diving-center/renovation-diving-center.component'
      ).then(r => r.RenovationDivingCenterComponent),
  })),

  ...routeStructure['renovationProDiver'].map(path => ({
    path,
    loadComponent: () =>
      import(
        './web/renovation/renovation-pro-diver/renovation-pro-diver.component'
      ).then(r => r.RenovationProDiverComponent),
  })),

  {
    path: 'poliza/:poliza',
    loadComponent: () =>
      import('./web/poliza/poliza.component').then(r => r.PolizaComponent),
  },
  {
    path: 'cookies',
    loadComponent: () =>
      import('./web/cookies/cookies.component').then(r => r.CookiesComponent),
  },

  // ...routeStructure['accident'].map(path => ({
  //   path,
  //   loadComponent: () =>
  //     import(
  //       './web/accident-case/caso-accidente/caso-accidente.component'
  //     ).then(r => r.CasoAccidenteComponent),
  // })),
  // --------------------------------------------------------------------------

  // Pantalla interna de pruebas de la integración con mediQUO (pública).
  // El código de cliente va en la URL para poder abrir varias conversaciones
  // en pestañas distintas y compartir el enlace de una en concreto.
  {
    path: 'mediquo-test',
    loadComponent: () =>
      import('./web/mediquo-test/mediquo-test.component').then(
        r => r.MediquoTestComponent
      ),
  },
  {
    path: 'mediquo-test/:clientCode',
    loadComponent: () =>
      import('./web/mediquo-test/mediquo-test.component').then(
        r => r.MediquoTestComponent
      ),
  },

  { path: '**', component: Error404Component },
];
